import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "../lib/business";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-primary text-white mt-12">
      <div className="container-x py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img
            src={BUSINESS.logo}
            alt="Abid Home Solutions LLC"
            className="h-20 w-auto object-contain bg-white rounded-xl p-2"
          />
          <p className="text-white/80 mt-4 max-w-md">{BUSINESS.slogan}</p>
          <p className="text-white/60 text-sm mt-4 max-w-md leading-relaxed">
            Local handyman & home services — TV mounting, furniture assembly, appliance
            installation, fitness equipment assembly, and moving help near 20878.
          </p>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest text-accent font-bold">Explore</h4>
          <ul className="mt-4 space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-white/80 hover:text-accent transition-colors text-sm"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest text-accent font-bold">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="flex items-start gap-2 text-white/90 hover:text-accent">
                <Phone size={16} className="mt-0.5" /> {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a href={BUSINESS.emailHref} data-testid="footer-email-link" className="flex items-start gap-2 text-white/90 hover:text-accent break-all">
                <Mail size={16} className="mt-0.5" /> {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-start gap-2 text-white/80">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span>{BUSINESS.serviceArea}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-5 text-xs text-white/60 flex flex-col sm:flex-row gap-2 justify-between">
          <span>© 2026 Abid Home Solutions LLC. All rights reserved.</span>
          <span>Serving Montgomery County, Frederick, DC, McLean, Alexandria & nearby.</span>
        </div>
      </div>
    </footer>
  );
}
